module.exports = __webpack_public_path__ + "img/BreakThroughLogo.00ac3b50.svg";